/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FundingRequestDtoExpenseItem
 */
export interface FundingRequestDtoExpenseItem {
  /**
   *
   * @type {string}
   * @memberof FundingRequestDtoExpenseItem
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof FundingRequestDtoExpenseItem
   */
  name: string;
}

export function FundingRequestDtoExpenseItemFromJSON(json: any): FundingRequestDtoExpenseItem {
  return FundingRequestDtoExpenseItemFromJSONTyped(json, false);
}

export function FundingRequestDtoExpenseItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FundingRequestDtoExpenseItem {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function FundingRequestDtoExpenseItemToJSON(value?: FundingRequestDtoExpenseItem | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
  };
}
